<template>
	<div class="change-account">
		<!-- <button @click="onChangeAccountClick" class="btn btn-small btn-round" v-if="hasMoreAccounts">{{ $t('base.account.change_account') }}</button> -->
		<modal-box v-if="hasMoreAccounts && modalBox.open" @close="onModalBoxClose" :header="$t('base.account.change_account')">
			<input-radio-v2 v-model="selectedAccount" :options="options" name="account_selected" :placeholder="$t('base.account.accounts')" rules="required"/>
		</modal-box>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'change-account',
	data () {
		return {
			modalBox: {
				open: false
			}
		}
	},
	computed: {
		hasMoreAccounts () {
			return this.accounts.length > 1
		},
		options () {
			const options = []
			if (this.accounts.length) {
				// owner account
				options.push({ value: this.user.uid, text: this.user.fullname })
				this.accounts.forEach(account => {
					options.push({ value: account.uid, text: account.fullname })
				})
			}
			return options
		},
		selectedAccount: {
			get () {
				return this.currentUser.uid
			},
			set (newVal) {
				const accountSelected = this.findAccounts(newVal)
				if (accountSelected !== undefined) {
					this.$store.dispatch('CHANGE_USER', accountSelected)
					this.$router.push({ name: 'Dashboard', params: { user_uid: newVal } })
				}
				// this.$store.dispatch('setUserSelectedAccount', newVal)
				// this.$router.push({ name: 'Dashboard', params: { user_uid: newVal } })
				this.modalBox.open = false
			}
		},
		...mapGetters({
			accounts: 'ACCOUNTS',
			findAccounts: 'FIND_ACCOUNTS',
			user: 'USER',
			currentUser: 'CURRENT_USER'
		})
	},
	methods: {
		onChangeAccountClick () {
			this.modalBox.open = true
		},
		onModalBoxClose () {
			this.modalBox.open = false
		}
	},
	mounted() {
		this.$root.$on('change-account', () => this.onChangeAccountClick())
	},
	destroyed() {
		this.$root.$off('change-account')
	}
}
</script>

<style scoped>
	.change-account {
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/navigation/account/ChangeAccount.vue